import(/* webpackMode: "eager" */ "/vercel/path0/app/service/page.jsx");
